/* eslint-disable @typescript-eslint/naming-convention */

export enum AnswerFormat {
  AddMore = 'add-more',
  Choice = 'choice',
  ChoiceMultiple = 'multi_choice',
  ChoiceMultipleDropdown = 'multi_select_dropdown',
  Date = 'date',
  Document = 'document',
  Dropdown = 'dropdown',
  Group = 'group',
  Number = 'number',
  Text = 'text',
  YesNo = 'yes_no',
}

/* eslint-disable @typescript-eslint/naming-convention */
